import React, { useState, useEffect } from "react";
import { useInsertName } from "./utils/helpers";

const ContactIntroSection = ({ onTypingDone, animate = true }) => {
  const name = useInsertName();
  const line = `$ sag hallo, ${name}`;
  const [chars, setChars] = useState(animate ? 0 : line.length);
  const done = chars >= line.length;

  useEffect(() => {
    setChars(animate ? 0 : line.length);
  }, [animate, line.length]);

  useEffect(() => {
    if (!animate) {
      onTypingDone?.();
      return;
    }

    if (chars < line.length) {
      const t = setTimeout(() => setChars((c) => c + 1), 70);
      return () => clearTimeout(t);
    }
    // Headline fertig — kurze Pause, dann Info-Terminal starten
    const t = setTimeout(() => onTypingDone?.(), 800);
    return () => clearTimeout(t);
  }, [chars, line.length, onTypingDone, animate]);

  return (
    <div className="pt-20 pb-8 sm:pt-24 sm:pb-10 md:pt-28 md:pb-12">
      <div className="container mx-auto text-center px-6 max-w-4xl font-mono">
        <p className="text-[10px] sm:text-xs uppercase tracking-[0.22em] text-[#EFEBDC]/35 mb-3">
          <span className="text-[#AC8E66]/80">$</span> contact
        </p>

        <h1 className="text-[21px] sm:text-[25px] md:text-[29px] font-semibold text-[#EFEBDC] mb-2 leading-snug tracking-[0.01em]">
          {line.slice(0, chars)}
          {!done && (
            <span className="inline-block w-[3px] h-[1em] bg-[#AC8E66] ml-0.5 align-middle animate-cursor-blink" />
          )}
        </h1>

        <p className="text-xs sm:text-sm text-[#EFEBDC]/65 max-w-xl mx-auto leading-relaxed">
          <span className="text-[#AC8E66]/80">&gt;</span> ob fragen zu projekten oder einfach nur fuer ein moin.
        </p>
      </div>
    </div>
  );
};

export default ContactIntroSection;
